// extracted by mini-css-extract-plugin
export default {"scrollbar":"HVScrollBar_module-6FFHAGLA_scrollbar__07kMj","thumb":"HVScrollBar_module-6FFHAGLA_thumb__DWqtQ"};